import yup from "../../../utils/yup-extended";

const step1Schema = yup.object().shape({
  firstName: yup.string().trim().required("First name is required"),
  lastName: yup.string().trim().required("Last name is required"),
  shortBio: yup.string().trim(),
  country: yup.string().trim().required("Please select a country"),
  username: yup
    .string()
    .trim("Spaces are not allowed")
    .noSpaces()
    .lowercase("Only lowercase letters")
    .required("Username is required"),
  shortDescription: yup.string().trim(),
  socials: yup.array().of(
    yup.object().shape({
      name: yup.string().trim(),
      // link: yup.string().trim(),
      link: yup.string().urlWithEmoji().trim(),
    })
  ),
  how_did_you_find_us: yup.string().required("Please select an option"),
  how_did_you_find_us_other: yup
    .string()
    .typeError("Must be a valid string")
    .when("how_did_you_find_us", {
      is: (how_did_you_find_us_other: string) => how_did_you_find_us_other === "other",
      then: (schema) => schema.required("This is a required field"),
      otherwise: (schema) => schema,
    }),
  displayName: yup.string().trim().required("Display name is required"),
});

export {step1Schema};
